import { axios, handleError } from '../axios';

export const adminAllEventSeen = () => {
  return new Promise((resolve, reject) => {
    axios
      .post('admin/events/seen')
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
